import React from 'react'
import { createRoot } from 'react-dom/client'
import CustomerPortalReact from '../main_app/CustomerPortalReact'

// Render component with data
document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('customer-portal-react')
  const data = JSON.parse(container.getAttribute('data'))
  const root = createRoot(container)
  root.render(<CustomerPortalReact {...data} />)
})
